import { updateNav as updateNavV1 } from "@bracket/contractor-next/bracket-vault";
import { updateNav as updateNavV2 } from "@bracket/contractor-next/bracket-vault-v2";
import type { Nav } from "@bracket/prisma";
import { type BlockHash, isBlockHash } from "@bracket/types";
import type { LoadedVault } from "@types";
import { isUserWalletRejection } from "@utils";
import { wagmiConfig as config } from "@wagmiconfig";

export declare type ProcessNavUpdateResult =
	| {
			success: true;
			hash: BlockHash;
	  }
	| {
			success: false;
			rejected: true;
	  }
	| {
			success: false;
			rejected: false;
			error: Error;
	  };

export const processNavUpdate = async (
	vault: LoadedVault,
	nav: Nav,
): Promise<ProcessNavUpdateResult> => {
	try {
		const { address, version, chainId } = vault;
		const updateNav = version === "2" ? updateNavV2 : updateNavV1;

		const hash = await updateNav({
			vault: address,
			newNav: nav.onav.toString(),
			managerPerformanceFee: nav.manager_performance_fee.toString(),
			managerTvlFee: nav.manager_tvl_fee.toString(),
			brktTvlFee: nav.bracket_tvl_fee.toString(),
			config,
			chainId,
		});

		if (isBlockHash(hash)) {
			return {
				success: true,
				hash,
			};
		}

		throw new Error("processNavUpdate failed to produce a valid blockhash");
	}
	catch (err) {
	
		if(isUserWalletRejection(err)) {
			return {
				success: false,
				rejected: true,
			};
		}

		console.warn([ "vaultSlice::processNavUpdate",err instanceof Error ? err.message : "no Error instance produced"].join("\n"));

		return {
			success: false,
			rejected: false,
			error: err as Error,
		};
	}
};
